<div class="contenedor authTemplate" [ngClass]="{ esModal: esModal }">
  <div class="row arriba" *ngIf="!esModal">
    <div class="col-12 col-lg-7 p-4">
      <div class="w-100 d-flex justify-content-between">
        <a href="" class="btn" (click)="back()">ATRÁS</a>
        <a href="/home" class="btn">HOME</a>
      </div>
    </div>
  </div>

  <div class="row">
    <!-- FORMULARIO -->
    <div class="col-12 col-lg-7 p-5">
      <div class="w-100 h-100 d-flex justify-content-center align-items-center">
        <div class="caja">
          <!-- Default form register -->
          <form class="text-center" [formGroup]="registroForm" (ngSubmit)="onSubmit()">
            <div class="titulo mb-1">Registrarse en +Cinemateca</div>

            <div class="row justify-content-lg-center my-3">
              <div class="col-12 col-lg-10">
                <div class="alert alert-light" role="alert">
                  <strong>+Cinemateca</strong> es una plataforma exclusiva para territorio uruguayo
                </div>
              </div>
            </div>

            <div class="row">
              <!-- Nombre -->
              <div class="col-12 col-lg-6 form-group mb-4 text-left">
                <input type="text" class="form-control" placeholder="Nombre" formControlName="firstName" />

                <ng-container *ngIf="registroForm.get('firstName').invalid && registroForm.get('firstName').touched">
                  <div *ngIf="registroForm.get('firstName').errors?.required" class="text-danger">
                    Debe ingresar un nombre.
                  </div>
                </ng-container>
              </div>

              <!-- Apellido -->
              <div class="col-12 col-lg-6 form-group mb-4 text-left">
                <input type="text" class="form-control" placeholder="Apellido" formControlName="lastName" />

                <ng-container *ngIf="registroForm.get('lastName').invalid && registroForm.get('lastName').touched">
                  <div *ngIf="registroForm.get('lastName').errors?.required" class="text-danger">
                    Debe ingresar un apellido.
                  </div>
                </ng-container>
              </div>
            </div>

            <div class="row">
              <!-- Email -->
              <div class="col-12 col-lg-7 form-group mb-4 text-left">
                <input type="email" class="form-control" placeholder="E-mail" formControlName="email" />

                <ng-container *ngIf="registroForm.get('email').invalid && registroForm.get('email').touched">
                  <div *ngIf="registroForm.get('email').errors?.required" class="text-danger">
                    Debe ingresar un correo.
                  </div>
                  <div *ngIf="registroForm.get('email').errors?.email" class="text-danger">
                    Debe ingresar un correo válido.
                  </div>
                </ng-container>
              </div>

              <!-- Documento -->
              <div class="col-12 col-lg-5 form-group mb-4 text-left">
                <input type="text" class="form-control" placeholder="Documento" formControlName="documentId" />

                <ng-container *ngIf="registroForm.get('documentId').invalid && registroForm.get('documentId').touched">
                  <div *ngIf="registroForm.get('documentId').errors?.required" class="text-danger">
                    Debe ingresar un número de documento.
                  </div>
                  <div *ngIf="registroForm.get('documentId').errors?.documentId" class="text-danger">
                    Debe ingresar un documento válido.
                  </div>
                </ng-container>
              </div>
            </div>

            <div class="row">
              <!-- Phone -->
              <div class="col-12 col-lg-6 form-group mb-4 text-left">
                <input type="text" class="form-control" placeholder="Teléfono" formControlName="phoneNumber" />

                <ng-container
                  *ngIf="registroForm.get('phoneNumber').invalid && registroForm.get('phoneNumber').touched">
                  <div *ngIf="registroForm.get('phoneNumber').errors?.required" class="text-danger">
                    Debe ingresar un número de teléfono/celular.
                  </div>
                  <div *ngIf="registroForm.get('phoneNumber').errors?.pattern" class="text-danger">
                    Debe ingresar un número de teléfono/celular válido.
                  </div>
                </ng-container>
              </div>

              <!-- Zip Code -->
              <div class="col-12 col-lg-6 form-group mb-4 text-left">
                <input type="text" class="form-control" placeholder="Código Postal" formControlName="zipcode" />

                <ng-container *ngIf="registroForm.get('zipcode').invalid && registroForm.get('zipcode').touched">
                  <div *ngIf="registroForm.get('zipcode').errors?.required" class="text-danger">
                    Debe ingresar un código.
                  </div>
                  <div *ngIf="registroForm.get('zipcode').errors?.pattern" class="text-danger">
                    Debe ingresar un código válido.
                  </div>
                </ng-container>
              </div>
            </div>

            <div class="row">
              <!-- Dirección -->
              <div class="col-12 col-lg-12 form-group mb-4 text-left">
                <input type="text" class="form-control" placeholder="Dirección completa" formControlName="address" />

                <ng-container *ngIf="registroForm.get('address').invalid && registroForm.get('address').touched">
                  <div *ngIf="registroForm.get('address').errors?.required" class="text-danger">
                    Debe ingresar una dirección.
                  </div>
                </ng-container>
              </div>
            </div>

            <div class="row">
              <!-- Ciudad -->
              <div class="col-12 col-lg-4 form-group mb-4 text-left">
                <input type="text" class="form-control" placeholder="Ciudad" formControlName="city" />

                <ng-container *ngIf="registroForm.get('city').invalid && registroForm.get('city').touched">
                  <div *ngIf="registroForm.get('city').errors?.required" class="text-danger">
                    Debe ingresar una ciudad.
                  </div>
                </ng-container>
              </div>

              <!-- Departamento -->
              <div class="col-12 col-lg-4 form-group mb-4 text-left">
                <input type="text" class="form-control" placeholder="Departamento" formControlName="state" />

                <ng-container *ngIf="registroForm.get('state').invalid && registroForm.get('state').touched">
                  <div *ngIf="registroForm.get('state').errors?.required" class="text-danger">
                    Debe ingresar un departamento.
                  </div>
                </ng-container>
              </div>

              <!-- Pais -->
              <div class="col-12 col-lg-4 form-group mb-4 text-left">
                <input type="text" class="form-control" placeholder="País" formControlName="country" />

                <ng-container *ngIf="registroForm.get('country').invalid && registroForm.get('country').touched">
                  <div *ngIf="registroForm.get('country').errors?.required" class="text-danger">
                    Debe ingresar un país.
                  </div>
                </ng-container>
              </div>
            </div>

            <br *ngIf="!esModal" />
            <br *ngIf="!esModal" />

            <div class="form-group mt-3">
              <button class="btn btn-block btn-lg my-4" type="submit" [ngClass]="{ disabled: !registroForm.valid }">
                <span *ngIf="cargando" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span *ngIf="!cargando">Enviar</span>
              </button>
            </div>

            <!-- Login -->
            <p>¿Ya tenés una cuenta? <a (click)="login()">Login</a></p>
          </form>
        </div>
      </div>
    </div>

    <div class="col-5 p-0 d-none d-lg-inline">
      <div class="imagen"></div>
      <div class="mosaico"></div>
    </div>
  </div>
</div>